const headers = [{ path: 'login', element: null, exact: true }];

export default headers;
